// extracted by mini-css-extract-plugin
export default {"pitchContainer":"Pitch_pitchContainer__5+-NT","pitchTabs":"Pitch_pitchTabs__nZz4o","active":"Pitch_active__1YyTJ","downloadBtn":"Pitch_downloadBtn__Q5PKa"};